import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import styles from './TrendingSearches.module.css';

interface TrendingSearchesProps {
  tags: string[];
  onTagClick: (tag: string) => void;
}

const tagColors = [
  'var(--accent-green)',
  'var(--accent-red)',
  'var(--accent-yellow)',
  'var(--accent-light-blue)',
  'var(--accent-purple)',
  'var(--accent-grey)'
];

const TrendingSearches: React.FC<TrendingSearchesProps> = ({ tags, onTagClick }) => {
  const getTagColor = (index: number) => {
    return tagColors[index % tagColors.length];
  };

  return (
    <Box className={styles.container}>
      <Typography variant="h6" className={styles.sectionTitle}>
        TRENDING SEARCHES
      </Typography>
      
      <Box className={styles.tagsContainer}>
        {tags.map((tag, index) => (
          <Chip
            key={tag}
            label={tag.toUpperCase()}
            onClick={() => onTagClick(tag)}
            className={styles.tagChip}
            style={{ backgroundColor: getTagColor(index) }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default TrendingSearches;